/** Converte sequências literais `\uXXXX` (ex.: `\u00e7`) em caracteres UTF-8 reais. */
export function decodeLiteralUnicodeEscapes(text: string): string {
  if (!text || !text.includes('\\u')) return text;
  return text.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex: string) =>
    String.fromCharCode(parseInt(hex, 16))
  );
}

/** Percorre objetos/arrays e decodifica strings (útil para payloads vindos do Dynamo). */
export function decodeLiteralUnicodeEscapesDeep<T>(value: T): T {
  if (typeof value === 'string') return decodeLiteralUnicodeEscapes(value) as T;
  if (Array.isArray(value)) return value.map((item) => decodeLiteralUnicodeEscapesDeep(item)) as T;
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[k] = decodeLiteralUnicodeEscapesDeep(v);
    }
    return out as T;
  }
  return value;
}
